import { PARSLEY_STATIC_URL } from './urls';
const fontSources = {
    euclidCircularBRegular: `${PARSLEY_STATIC_URL}/fonts/euclid-circular-b/euclid-circular-b-regular.woff`,
    euclidCircularBMedium: `${PARSLEY_STATIC_URL}/fonts/euclid-circular-b/euclid-circular-b-medium.woff`,
    baskerville: `${PARSLEY_STATIC_URL}/fonts/baskerville/baskerville-normal.woff`
};
export default fontSources;
//# sourceMappingURL=font-sources.js.map